export const GLINTS_TRACKING_EVENT_QUEUE_KEY = 'glints_tracking_event_queue';
export type UserProperties = {
  device_id: string;
  user_id: string | null;
  device_type: string | null | undefined;
  os_version: string | null | undefined;
  os_name: string | null | undefined;
  exp_info: Record<string, unknown> | null | undefined;
  country_code: string | null | undefined;
};

export type GlintsTrackingEvent = {
  event_id: string;
  event_time: number; // milliseconds since epoch
  event_type: string;
  properties: Record<string, unknown> | null;
};

export type GlintsTrackingBatchEvent = {
  event_category: 'biz_employer_batch';
  session_id: string;
  batch_timestamp: number;
  user_properties: UserProperties;
  events: GlintsTrackingEvent[];
};

export type PreviousPageInfo = {
  pageName: string;
  pageViewTime: number;
  pagePath: string;
};
